import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 z-9999 flex w-full justify-center items-center">
      <div className="w-6 h-6 border-4 border-x-gray-700 border-y-white border-solid rounded-full animate-spin"></div>
    </div>
  );
};

export default LoadingSpinner;
